export default __webpack_public_path__ + "15957c2.png";